var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-player"},[_c('div',{staticClass:"video-tool-bar"},[_c('div',{staticClass:"video-close-btn",on:{"click":_vm.close}},[_vm._v("关闭")])]),_c('video',{attrs:{"src":_vm.url,"controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }